import React from "react";
import { SealCheck } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

// Verified Founding Member — first 20 companies per city during Early Access.
export const FoundingBadge = ({ fm, size = "sm", className = "" }) => {
  const { t } = useLang();
  if (!fm) return null;
  const big = size === "lg";
  return (
    <span
      data-testid="founding-badge"
      title={`${t("founding_badge")} · #${fm.number} · ${fm.city}`}
      className={`founding-badge inline-flex items-center gap-1.5 rounded-full ${big ? "px-3.5 py-1.5 text-[13px]" : "px-2 py-0.5 text-[11px]"} ${className}`}
    >
      <SealCheck size={big ? 16 : 12} weight="fill" />
      <span className="truncate">{t("founding_badge")}</span>
      {big && <span className="opacity-70">#{fm.number} · {fm.city}</span>}
    </span>
  );
};
